import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { AngularSvgIconModule } from "angular-svg-icon";
import { LoggerService } from "../../../ancestors/logger.service";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { UrlCollection } from "../../constants/url-collection";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";

/**
 * Componente per il pulsante Home nell'header
 * Componente immutabile con configurazione fissa
 *
 * Caratteristiche:
 * - Icona della casa centrata con dimensioni ottimizzate
 * - Supporto completo per accessibilità (ARIA labels, keyboard navigation)
 * - Stati di hover, focus
 * - Navigazione automatica alla homepage
 */
@Component({
  selector: "ape-header-home-button",
  templateUrl: "./ape-header-home-button.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    AngularSvgIconModule,
    TranslatePipe
  ]
})
export class ApeHeaderHomeButtonComponent {
  /**
   * Chiavi di traduzione per type safety
   */
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  private router = inject(Router);

  private logger = inject(LoggerService);

  constructor() {
    this.logger.setCaller(this.constructor.name);
  }

  /**
   * Gestisce il click sul pulsante home
   * Naviga alla homepage appropriata in base al contesto:
   * - Admin: naviga alla home admin
   * - Employee: naviga alla home employee
   * @param event - Evento del click o tastiera
   */
  protected onHomeClick(event: Event): void {
    event.preventDefault();

    // Determina se siamo nel portale admin controllando la URL corrente
    const isAdminPortal = this.router.url.startsWith("/admin");

    // Naviga alla homepage appropriata
    const targetUrl = isAdminPortal
      ? UrlCollection.adminHomepage
      : UrlCollection.homepage;

    this.logger.info(`Navigating to home: ${targetUrl} (isAdminPortal: ${isAdminPortal})`);

    void this.router.navigate([targetUrl]);
  }
}
